module.exports = __webpack_public_path__ + "static/media/exclamation.1b7bcec5.jpg";